import { apiFetch } from "./client";

export function getMessages() {
  return apiFetch("/api/messages");
}

export function addCategory(key) {
  return apiFetch("/api/messages/categories", {
    method: "POST",
    body: { key },
  });
}

export function deleteCategory(key) {
  return apiFetch(`/api/messages/categories/${encodeURIComponent(key)}`, {
    method: "DELETE",
  });
}

export function addMessage(key, text) {
  return apiFetch(`/api/messages/categories/${encodeURIComponent(key)}/messages`, {
    method: "POST",
    body: { text },
  });
}

export function updateMessage(key, index, text) {
  return apiFetch(`/api/messages/categories/${encodeURIComponent(key)}/messages/${index}`, {
    method: "PUT",
    body: { text },
  });
}

export function deleteMessage(key, index) {
  return apiFetch(`/api/messages/categories/${encodeURIComponent(key)}/messages/${index}`, {
    method: "DELETE",
  });
}

export function cleanupMessages() {
  return apiFetch("/api/messages/cleanup", { method: "POST" });
}
